// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://indigo-raven-856234.hostingersite.com/",
});

export default axiosInstance;

// export const weburl = "https://manjit-jewellers-backend.onrender.com/";
export const weburl = "https://manjit-jewellers-backend.onrender.com/";
export const testurl = "https://manjit-jewellers-backend.onrender.com/";
export const ImageServer = "https://midnightblue-seal-752209.hostingersite.com/";

export const shopurl = "https://adminmanjit.servicekarwalo.com/";
export const mainurl = "https://makeintern.servicekarwalo.com/";
export const fronturl = "https://makeintern.servicekarwalo.com/";


export const keyLogin = process.env.REACT_APP_LOGIN_KEY;